import { render, staticRenderFns } from "./TprPro.vue?vue&type=template&id=9a1fd7a4&scoped=true"
import script from "./TprPro.vue?vue&type=script&lang=js"
export * from "./TprPro.vue?vue&type=script&lang=js"
import style0 from "./TprPro.vue?vue&type=style&index=0&id=9a1fd7a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a1fd7a4",
  null
  
)

export default component.exports